/**
 * @generated SignedSource<<b285a02707f08526265baa4e62bcf323>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RequestShippingQuoteModal_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"RequestShippingQuoteBody_viewer">;
  readonly " $fragmentType": "RequestShippingQuoteModal_viewer";
};
export type RequestShippingQuoteModal_viewer$key = {
  readonly " $data"?: RequestShippingQuoteModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"RequestShippingQuoteModal_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RequestShippingQuoteModal_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestShippingQuoteBody_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "5a39279e3c915810c990b9ab698dd3f6";

export default node;
